/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import Icon from '@mui/icons-material/Check'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyles from 'shared/hooks/useStyle'

import styles from './YesNoStep.style'

const propTypes = {
    choice: PropTypes.shape({
        choiceIdentifier: PropTypes.string.isRequired,
        choiceLabel: PropTypes.string.isRequired,
    }).isRequired,
    selected: PropTypes.bool,
    onChoice: PropTypes.func.isRequired,
    testId: PropTypes.string.isRequired,
}

const ChoiceButton = ({
    choice,
    selected = null,
    onChoice,
    testId,
}) => {
    const { t } = useTranslation()
    const classes = useStyles(styles)

    return (
        <Button
            name={choice.choiceIdentifier}
            data-testid={testId}
            css={[
                classes.button,
                selected !== null && !selected && classes.inactive,
            ]}
            onClick={onChoice}
            startIcon={selected ? <Icon /> : <></>}
        >
            {t(`processDefinition:${choice.choiceLabel}`)}
        </Button>
    )
}

ChoiceButton.propTypes = propTypes

export default ChoiceButton
